import React, { useState } from 'react';
import { Button, Modal, Input, message, Cascader, Select } from 'antd';
import { Download } from 'react-bootstrap-icons';
import { httpClient } from "../services/http.service";

export const displayRender = (labels) => labels[labels.length - 1];

export const repairsCode = {
  "ROXY 40": [
    {
      name:"Unit exchanged",
      codes:[
        {text:"Unit exchanged Old",code:"XB0"},
        {text:"Unit exchanged",code:"XB"},
        {
          text: "Unit exchanged under exchange program, no issues found",
          code: "XB1",
        }
      ]
    },
  {
      name: "Other Issues",
      image: "assets/roxy-40/Belt loops.JPG",
      codes: [
        { text: "Bag replacement", code: "BREP" },
        { text: "Leaking", code: "U4" },
        
      ],
    },
     
    {
      name: "Moisture Indicator ",
      image: "assets/roxy-40/moistureIndicator.jpg",
      codes: [
        {
          text: "Moisture indicator changed colour",
          code: "I1",
        },
        {
          text: "Moisture indicator cracked/damaged",
          code: "I2",
        },
        { text: "Moisture Indicator Missing", code: "I3" },
      ],
    },
    {
      name: "Belt Loops",
      image: "assets/roxy-40/Belt loops.JPG",
      codes: [
        { text: "Broken belt loop", code: "B1" },
        { text: "Belt loop razor edges", code: "B2" },
        { text: "Belt loop missing", code: "B3" },
        { text: "Lever flanges bent", code: "C9" },
      ],
    },
    {
      name: "Side Plate",
      image: "assets/roxy-40/primarySeal.png",
      codes: [
        { text: "Primary seal missing", code: "S1" },
        {
          text: "Security seal (secondary seal) missing",
          code: "S2",
        },
      ],
    },
    {
      name: "Casing",
      image: "assets/roxy-40/cassing.png",
      codes: [
        {
          text: "Casing covered with gunnite, glue etc",
          code: "C1",
        },
        {
          text: "Casing damaged by electrical current",
          code: "C2",
        },
        { text: "Casing cracked", code: "C3" },
        { text: "Unit emptyd", code: "C4" },
        { text: "Unit damaged", code: "C5" },
        { text: "Unit crushed", code: "C6" },
        {
          text: "Unit burnt by mine (damaged by heat from brazing / welding / flame cutting)",
          code: "C7",
        },
        { text: "Casing has undue wear and tear", code: "C8" },
        { text: "Lid damaged", code: "C10" },
        {
          text: "External presence of diesel and oil",
          code: "O2",
        },
        { text: "Unit covered in paint", code: "O6" },
        { text: "External presence of paint", code: "O7" },
        { text: "Signs of corrosion", code: "U3" },
        
      ],
    },
  ],
  "AFROX PACK 35i": [
    {
      name: "Unit exchanged under exchange program",
      image: "assets/roxy-40/moistureIndicator.jpg",
      codes: [
        {
          text: "Unit exchanged under exchange program, no issues found",
          code: "XB",
        }
      ],
    },
    {
      name: "Casing/Container",
      image: "assets/afrox/cassing.jpg",
      codes: [
        { text: "Unit Crushed", code: "Unit Crushed" },
        { text: "Unit battery arced", code: "Unit battery arced" },
        { text: "Hole under belt loop", code: "Hole under belt loop" },
        { text: "Top corners warn through", code: "Top corners warn through" },
        { text: "Bottom corners warn through", code: "Bottom corners warn through" },
        { text: "Unit cement covered", code: "Unit cement covered" },
        { text: "Unit has crack in corner", code: "Unit has crack in corner" },
        { text: "Unit is empty", code: "Unit is empty" },
        { text: "Unit has carry strap", code: "Unit has carry strap" },
        { text: "Unit has unnecessary dents", code: "Unit has unnecessary dents" },
        { text: "Unit vandalized", code: "Unit vandalized" },
        { text: "Cover wrong way", code: "Cover wrong way" },
      ],
    },
    {
      name: "Primary Seal",
      image: "assets/afrox/primary_seal.jpg",
      codes: [
        { text: "Primary seal missing", code: "Primary seal missing" },
      ],
    },
    {
      name: "Secondary Seal",
      image: "assets/afrox/secondary_seal.jpg",
      codes: [
        { text: "Secondary seal missing", code: "Secondary seal missing" },
      ],
    },
    {
      name: "Release Lever",
      image: "assets/afrox/release_lever.jpg",
      codes: [
        { text: "Cement under release lever", code: "Cement under release lever" },
        { text: "Release Lever damadged", code: "Release Lever damadged" },
      ],
    },
    {
      name: "Belt Loops",
      image: "assets/afrox/belt_loops.jpg",
      codes: [
        { text: "Belt loop broken", code: "Belt loop broken" },
        { text: "Belt loop Sharp edges", code: "Belt loop Sharp edges" },
        { text: "Belt loop bend", code: "Belt loop bend" },
      ],
    },
    {
      name: "Moisture Indicator",
      image: "assets/afrox/moisture_indicator.jpg",
      codes: [
        { text: "Moisture indicator is white/pink", code: "Moisture indicator is white/pink" },
        { text: "Moisture indicator Broken", code: "Moisture indicator Broken" },
      ],
    },
    {
      name: "Serial Number",
      image: "assets/afrox/serial_number.jpg",
      codes: [
        { text: "Serial number not visible", code: "Serial number not visible" },
      ],
    },
    {
      name: "Closing Strap",
      image: "assets/afrox/closing_strap.jpg",
      codes: [
        { text: "Closing Stap Dammedged", code: "Closing Stap Dammedged" },
      ],
    },
  ],
};

export function DownloadRFQOverride({ rfqId, disabled, model }) {
  const [isLoading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [statusOverride, setStatusOverride] = useState('');
  const [selectedModel, setSelectedModel] = useState(model || 'ROXY 40');
  const [issueDiscovered, setIssueDiscovered] = useState([]);
  const [comments, setComments] = useState('');

  const handleOverride = async () => {
    if (!statusOverride) {
      message.error('Please select a status');
      return;
    }

    setLoading(true);
    try {
      const issueDetails = issueDiscovered.map(issues => issues[1]).join(", ");
      
      await httpClient.post(`/api/v1/RFQ/${rfqId}/status-override`, {
        status: statusOverride,
        issueDiscovered: issueDetails,
        comments: comments
      });

      message.success('Status override applied successfully');
      setStatusOverride('');
      setIssueDiscovered([]);
      setComments('');
      setIsModalVisible(false);
    } catch (err) {
      message.error(err?.response?.data?.message || err?.message || 'Failed to apply status override');
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setStatusOverride('');
    setIssueDiscovered([]);
    setComments('');
  };

  const cascaderOptions = repairsCode[selectedModel]?.map((repairCode) => {
    let children = repairCode?.codes?.map((code) => ({
      value: `${code.code} - ${code.text}`,
      label: `${code.code} - ${code.text}`,
    }));

    return {
      value: repairCode.name,
      label: repairCode.name,
      children: children,
    };
  });

  return (
    <>
      <Button 
        style={{ margin: "5px" }} 
        disabled={isLoading || disabled} 
        size='sm' 
        onClick={showModal}
      > 
        <Download /> {isLoading ? 'Processing...' : 'Download RFQ Override'}
      </Button>

      <Modal
        title="RFQ Status Override"
        visible={isModalVisible}
        onOk={handleOverride}
        onCancel={handleCancel}
        confirmLoading={isLoading}
        okText="Apply Override"
        cancelText="Cancel"
        width={600}
      >
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold' }}>Status:</label>
          <Select
            style={{ width: '100%' }}
            placeholder="Select status"
            value={statusOverride || undefined}
            onChange={(value) => setStatusOverride(value)}
            disabled={isLoading}
          >
            <Select.Option value="active">ACTIVE</Select.Option>
            <Select.Option value="inactive">INACTIVE</Select.Option>
            <Select.Option value="quarantined">QUARANTINED</Select.Option>
            <Select.Option value="collected">COLLECTED</Select.Option>
            <Select.Option value="repaired">REPAIRED</Select.Option>
            <Select.Option value="rrepair">RREPAIR</Select.Option>
            <Select.Option value="unrepairable">UNREPAIRABLE</Select.Option>
            <Select.Option value="enroute">ENROUTE</Select.Option>
            <Select.Option value="ber">BER</Select.Option>
            <Select.Option value="expired">EXPIRED</Select.Option>
          </Select>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold' }}>Model:</label>
          <Select
            style={{ width: '100%' }}
            value={selectedModel}
            onChange={(value) => {
              setSelectedModel(value);
              setIssueDiscovered([]);
            }}
          >
            <Select.Option value="ROXY 40">ROXY 40</Select.Option>
            <Select.Option value="AFROX PACK 35i">AFROX PACK 35i</Select.Option>
          </Select>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold' }}>Issue Discovered:</label>
          <Cascader
            style={{ width: '100%' }}
            multiple
            placeholder="Select issues discovered"
            options={cascaderOptions}
            expandTrigger="hover"
            displayRender={displayRender}
            value={issueDiscovered}
            onChange={(e) => setIssueDiscovered(e)}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold' }}>Comments:</label>
          <Input.TextArea
            placeholder="Enter comments for this override"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            disabled={isLoading}
            rows={3}
          />
        </div>
      </Modal>
    </>
  );
}
